"use client";
import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TopNavThree from "../../components/Header/TopNav/TopNavThree";
import MenuFurniture from "../../components/Header/Menu/MenuFurniture";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import Footer from "../../components/Footer/Footer";
import { useCart } from "../../context/CartContext";
import { useSearchParams } from "react-router-dom";
import { fetchProductImages, fetchProductText } from "../../data/Productlist";
import axios from "axios";
import success from "../../utils/success";
import warning from "../../utils/warning";
import * as Icon from "@phosphor-icons/react/dist/ssr";
import { generateOrderNumber } from "../../utils/orderUtils";
import { PromoCodeInput } from "../../components/PromoCode";
import { PromoCode, validatePromoCode, applyPromoCode } from "../../utils/promoUtils";
import { getApiUrl } from "../../config/api";
import { CheckoutSteps } from "../../components/CheckoutSteps";
import { makeCartVariantKey } from "../../utils/cartVariantKey";
import { tiktokTrackOrderPlaced, tiktokInitiateCheckout, tiktokAddPaymentInfo, getTikTokAttribution } from "../../utils/tiktokPixel";
import { analyticsOrderConverted } from "../../utils/analytics";
import {
  cartQualifiesForDeliveryPromo,
  resolveCheckoutShippingFee,
} from "../../utils/deliveryPromo";

const Checkout = () => {
  document.title = "Paiement | Kissaira"
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Add navigation state tracking
  const [isNavigating, setIsNavigating] = useState(false);
  const [hasInitialized, setHasInitialized] = useState(false);

  useEffect(() => {
    // Mark as initialized after component mounts
    setHasInitialized(true);
    
    // Handle browser back/forward navigation
    const handleBeforeUnload = () => {
      setIsNavigating(true);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  // Handle location changes
  useEffect(() => {
    if (hasInitialized) {
      setIsNavigating(false);
      // Ensure proper scroll position
      window.scrollTo(0, 0);
    }
  }, [location.pathname, hasInitialized]);

  let discount = searchParams.get("discount");
  let ship = searchParams.get("ship");
  const [livraison, setlivraison] = useState<{ city: string,standard:number,express:number,id:number }[]>([]);
  const [city, setCity] = useState<string>("")
  const [prix, setPrix] = useState<number>(0)

  const [deliveryType, setDeliveryType] = useState<string>('')
  const [deliveryPromoProductIds, setDeliveryPromoProductIds] = useState<Set<string>>(new Set())
  const [baseShippingFee, setBaseShippingFee] = useState<number>(0)


  const { cartState } = useCart();
  let [totalCart, setTotalCart] = useState<number>(0);
  const [activePayment, setActivePayment] = useState<string>(
    "paiement à la livraison"
  );
  const [expressavailable, setexpressavailable] = useState<boolean>();
  const [promoCode, setPromoCode] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  cartState.cartArray.map((item) => (totalCart += item.price * item.quantity));

  const handlePayment = (item: string) => {
    setActivePayment(item);
    if (cartDetails.length === 0) return;
    const subtotal = cartDetails.reduce(
      (sum, row) => sum + Number(row.price || 0) * Number(row.quantityPursh || 1),
      0
    );
    tiktokAddPaymentInfo({
      value: subtotal - promoDiscount + prix,
      contents: cartDetails.map((row) => ({
        content_id: String(row.id),
        content_name: String(row.name || ""),
        content_type: "product",
        quantity: Number(row.quantityPursh || 1),
        price: Number(row.price || 0),
      })),
    });
  };

  const [dataSourceProd, setDataSourceProd] = useState<any[]>([]);
  const [isOpenProduct, setisOpenProduct] = useState(true);
  const [isLoadingText, setIsLoadingText] = useState(true);
  const [isLoadingImages, setIsLoadingImages] = useState(true);

  const fetchData = async () => {
    try {
      // Fetch text data first
      const products = await fetchProductText();

      // Set text data first (without images)
      setDataSourceProd(products);
      setisOpenProduct(false);
      setIsLoadingText(false); // Text data loaded

      // Fetch images for the products after the text data is loaded
      const productsWithImages = await fetchProductImages(products);

      // Set the updated products with images
      setDataSourceProd(productsWithImages);

      setIsLoadingImages(false); // Images data loaded
    } catch (error) {
      console.error("Failed to fetch products: ", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const [cartDetails, setCartDetails] = useState<any[]>([]);
  const [cartDataLoaded, setCartDataLoaded] = useState(false);
  const [colorImages, setColorImages] = useState<{[key: number | string]: string}>({});

  const fetchColorImage = async (imageid: number | string) => {
    if (!imageid || colorImages[imageid]) return; // Already loaded or no imageid
    
    // Use direct path instead of API call
    const imagePath = `/images/${imageid}`;
    setColorImages(prev => ({
      ...prev,
      [imageid]: imagePath
    }));
  };

  const updateCartDetails = async () => {
    const cartItemsJSON = localStorage.getItem("cartItems");
    const cartItems: any[] = cartItemsJSON ? JSON.parse(cartItemsJSON) : [];

    // Build cart lines from cartItems so same product can appear multiple times
    // with different color/size/pointure.
    const updatedCartDetails = cartItems
      .map((cartItem) => {
        const product = dataSourceProd.find(
          (p) => Number(p.id) === Number(cartItem.id)
        );
        if (!product) return null;

        const variantKey = makeCartVariantKey({
          productId: cartItem.id,
          colorCode: cartItem.colorCode,
          sizeCode: cartItem.sizeCode,
          pointureCode: cartItem.pointureCode,
        });

        return {
          ...product,
          variantKey,
          quantityPursh: cartItem.quantity ?? 0,
          colorPursh: cartItem.color ?? "pas sélectionné",
          sizePursh: cartItem.size ?? "pas sélectionné",
          pointurePursh: cartItem.pointure ?? "pas sélectionné",
          colorCode: cartItem.colorCode ?? "pas sélectionné",
          sizeCode: cartItem.sizeCode ?? "pas sélectionné",
          colorImageId: cartItem.colorImageId ?? null,
          pointureCode: cartItem.pointureCode ?? "pas sélectionné",
          livraison: cartItem.livraison ?? "pas sélectionné",
        };
      })
      .filter(Boolean) as any[];

    // Set the updated cart details state
    setCartDetails(updatedCartDetails);
    setCartDataLoaded(true);

    // Set color images directly from cart data (only for products with characteristics)
    for (const product of updatedCartDetails) {
      if (product.colorImageId && !product.colorImageId.includes('.') && !product.colorImageId.startsWith('/')) {
        // Only fetch if it's a numeric ID (not a filename like "59-2.jpg")
        fetchColorImage(product.colorImageId);
      }
    }
  };
  useEffect(() => {
    const fetchCaracteristiques = async () => {
        try {
          const response = await fetch(getApiUrl('LIVRAISON'));
          const data = await response.json(); 
          setlivraison(data); 
        } catch (error) {
          console.error('Error fetching product characteristics:', error);
        }
    }
    fetchCaracteristiques()
  },[]);

  useEffect(() => {
    const fetchDeliveryPromo = async () => {
      try {
        const response = await fetch(getApiUrl('DELIVERY_PROMO'));
        const data = await response.json();
        const ids = Array.isArray(data?.product_ids) ? data.product_ids : [];
        setDeliveryPromoProductIds(new Set(ids.map((id: string | number) => String(id))));
      } catch (error) {
        console.error('Error fetching delivery promo products:', error);
      }
    };
    fetchDeliveryPromo();
  }, []);

  useEffect(() => {
    // Initialize the cart details on component mount
    updateCartDetails();

    // Set up an interval to update cart details every 2 seconds
    const intervalId = setInterval(updateCartDetails, 2000);

    // Clear the interval on component unmount
    return () => clearInterval(intervalId);
  }, [dataSourceProd]);

  // Redirect to cart if cart is empty
  useEffect(() => {
    // Only check after data has been loaded and component is initialized
    if (hasInitialized && dataSourceProd.length > 0 && cartDataLoaded) {
      // Add a small delay to ensure all data is properly loaded
      const timeoutId = setTimeout(() => {
        // Check both cartDetails and localStorage to ensure accuracy
        const cartItemsJSON = localStorage.getItem("cartItems");
        const cartItems = cartItemsJSON ? JSON.parse(cartItemsJSON) : [];
        
        if (cartItems.length === 0 && cartDetails.length === 0) {
          console.log("Cart is empty, redirecting to cart page");
          navigate('/cart');
        } else {
          console.log("Cart has items:", cartItems.length, "cartDetails:", cartDetails.length);
        }
      }, 1000); // Wait 1 second for data to load

      return () => clearTimeout(timeoutId);
    }
  }, [cartDetails.length, hasInitialized, dataSourceProd.length, cartDataLoaded, navigate]);

  const calculateTotalPrice = () => {
    return cartDetails.reduce((total, product) => {
      return total + product.price * product.quantityPursh;
    }, 0);
  };

  useEffect(() => {
    const total = calculateTotalPrice();
    setTotalCart(total);
  }, [cartDetails]);

  const [fullName, setFullName] = useState("");
  const [Tel, setTel] = useState("");
  const [email, setEmail] = useState("");
  const [Address, setAddress] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loadingProgress, setLoadingProgress] = useState(0);

  // Prevent scrolling when submitting order
  useEffect(() => {
    if (isSubmitting) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isSubmitting]);

  // Promo code state
  const [appliedPromoCode, setAppliedPromoCode] = useState<PromoCode | null>(null);
  const [promoDiscount, setPromoDiscount] = useState<number>(0);
  const [showPromoSuccess, setShowPromoSuccess] = useState(false);
  const [showPromoError, setShowPromoError] = useState(false);
  const [promoMessage, setPromoMessage] = useState('');
  const hasSelectedVariantValue = (value: unknown) => {
    if (value === null || value === undefined) return false;
    const str = String(value).trim().toLowerCase();
    return str !== "" && str !== "pas sélectionné" && str !== "0";
  };

  // Promo code handlers
  const handlePromoCodeApplied = (discount: number, promoCode: PromoCode) => {
    setAppliedPromoCode(promoCode);
    setPromoDiscount(discount);
    setPromoMessage(`Code promo ${promoCode.code} appliqué ! Économisez ${discount.toFixed(2)} MAD`);
    // If promo code is free shipping, set shipping to 0
    if (promoCode.type === 'free_shipping') {
      setPrix(0);
    }
    setShowPromoSuccess(true);
    // Hide success message after 4 seconds
    setTimeout(() => {
      setShowPromoSuccess(false);
    }, 4000);
  };

  const handlePromoCodeRemoved = () => {
    setAppliedPromoCode(null);
    setPromoDiscount(0);
    setPromoMessage('Code promo supprimé');
    setShowPromoSuccess(true);
    if (deliveryType) {
      setPrix(
        resolveCheckoutShippingFee(
          baseShippingFee,
          cartDetails,
          deliveryPromoProductIds,
          false
        )
      );
    }
    setTimeout(() => {
      setShowPromoSuccess(false);
    }, 3000);
  };

  const handleApplyPromoCode = async () => {
    if (!promoCode.trim()) {
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const validation = await validatePromoCode(
        promoCode.trim(),
        totalCart,
        undefined, // userId
        cartDetails.map(item => Number(item.id)),
        cartDetails.map(item => item.category).filter(Boolean)
      );

      if (validation.isValid && validation.promoCode) {
        const result = applyPromoCode(validation.promoCode, totalCart, prix);
        handlePromoCodeApplied(result.discount, validation.promoCode);
        setPromoCode('');
      } else {
        setError(validation.message || 'Code promo invalide.');
      }
    } catch (error) {
      console.error('Error applying promo code:', error);
      setError('Erreur lors de l\'application du code promo.');
    } finally {
      setIsLoading(false);
    }
  };

  const submitOrder = async (e: React.FormEvent<HTMLFormElement>) => {

    e.preventDefault();

    // Prevent duplicate submissions
    if (isSubmitting) {
      console.log("Order submission already in progress, ignoring duplicate request");
      return;
    }

    if (cartDetails.length <= 0) {
      warning("Votre panier est vide.");
      return;
    }

    // Validate required fields
    if (fullName.trim() === "") {
      warning("Veuillez saisir votre nom complet.");
      return;
    }

    if (Tel.trim() === "") {
      warning("Veuillez saisir votre numéro de téléphone.");
      return;
    }

    // Validate phone number format (only numbers and + symbol)
    const phoneRegex = /^[+]?[0-9\s\-\(\)]+$/;
    if (!phoneRegex.test(Tel)) {
      warning("Le numéro de téléphone ne doit contenir que des chiffres et le symbole '+' si nécessaire.");
      return;
    }

    // Remove all non-digit characters except + for length check
    const cleanPhone = Tel.replace(/[^\d+]/g, '');
    if (cleanPhone.length < 8) {
      warning("Le numéro de téléphone doit contenir au moins 8 chiffres.");
      return;
    }

    if (Address.trim() === "") {
      warning("Veuillez saisir votre adresse.");
      return;
    }

    if (city === "") {
      warning("Veuillez sélectionner une ville.");
      return;
    }

    if (deliveryType === "") {
      warning("Veuillez sélectionner une option de livraison.");
      return;
    }

    if (activePayment === "") {
      warning("Veuillez sélectionner un mode de paiement.");
      return;
    }
   
    // Validate email format if provided
    if (email.trim() !== "") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        warning("Veuillez saisir une adresse email valide (exemple: nom@domaine.com).");
        return;
      }
    }
   
    // Set loading state
    setIsSubmitting(true);
    setLoadingProgress(0);

    try {
      // Show loading state for 3 seconds to let user know order is processing
      const startTime = Date.now();
      const duration = 3000;
      
      const progressInterval = setInterval(() => {
        const elapsed = Date.now() - startTime;
        const progress = Math.min((elapsed / duration) * 100, 100);
        setLoadingProgress(progress);
      }, 50); // Update every 50ms for smooth progress
      
      await new Promise(resolve => setTimeout(resolve, 3000));
      clearInterval(progressInterval);
      setLoadingProgress(100);

      const clientData = {
        fullName,
        Tel,
        email,
      };

      console.log("Sending client data:", clientData);

      let clientResponse;
      try {
        clientResponse = await axios.post(
          getApiUrl('ORDER_CLIENT'),
        clientData
      );

        console.log("Client response:", clientResponse.data);
      } catch (error: any) {
        console.log("Client error response:", error.response?.data);
        console.log("Client error status:", error.response?.status);
        throw error;
      }

      if (clientResponse.data && clientResponse.data.id_client) {
        const id_client = clientResponse.data.id_client;

        // Generate order number once and reuse it
        const generatedOrderNumber = generateOrderNumber();
        console.log("Generated order number:", generatedOrderNumber);

        // Log the colorImageId values for debugging
        console.log("Cart details with colorImageId:", cartDetails.map(item => ({
          id: item.id,
          name: item.name,
          colorImageId: item.colorImageId,
          color: item.colorPursh
        })));

        const { ttclid, ttp } = getTikTokAttribution();
        const orderData = {
          code_article: cartDetails.map((item) => item.id),
          quantité_article: cartDetails.map((item) => item.quantityPursh),
          statuts: "En attente",
          mode_paiement: activePayment,
          id_client: id_client,
          prix_livraison: prix,
          addresse:Address,
          type_livraison:deliveryType,
          total:totalCart-promoDiscount+prix,
          num_commande: generatedOrderNumber,
          city:city,
          couleur: cartDetails.map((item) => item.colorCode),
          size: cartDetails.map((item) => item.sizeCode),
          pointure: cartDetails.map((item) => item.pointureCode),
          imageid: cartDetails.map((item) => item.colorImageId || null), // Add selected color image IDs
          timestamp: new Date().toISOString(),
          local_time: new Date().toLocaleString('fr-FR', { timeZone: 'Europe/Paris' }),
          promo_code: appliedPromoCode?.code || null,
          promo_discount: promoDiscount,
          subtotal: totalCart,
          ttclid: ttclid || null,
          ttp: ttp || null,
          page_url: typeof window !== "undefined" ? window.location.href.split("#")[0] : null,
        };

        console.log("Order data with imageid:", orderData);
        
        
        let orderResponse;
        try {
          orderResponse = await axios.post(
            getApiUrl('COMMANDES'),
          orderData
        );
        } catch (error: any) {
          console.log("Order error response:", error.response?.data);
          console.log("Order error status:", error.response?.status);
          throw error;
        }

        if (orderResponse.data.success) {
          console.log("Full order response:", orderResponse);
          console.log("Order response data:", orderResponse.data);
          console.log("Order response data keys:", Object.keys(orderResponse.data));
          
          // Record promo code usage if a promo code was applied
          if (appliedPromoCode && promoDiscount > 0) {
            try {
              console.log("Recording promo code usage:", appliedPromoCode.code);
              const promoUsageResponse = await axios.post(
                getApiUrl('PROMO_RECORD_USAGE'),
                {
                  promoCodeId: appliedPromoCode.id,
                  userId: id_client,
                  orderId: orderResponse.data.id || orderResponse.data.num_commande || generatedOrderNumber,
                  discount: promoDiscount
                }
              );
              console.log("Promo code usage recorded:", promoUsageResponse.data);
            } catch (error) {
              console.error("Error recording promo code usage:", error);
              // Don't fail the order if promo code recording fails
            }
          }
          
          // Always use our generated order number to maintain consistent format
          let orderNumber = generatedOrderNumber;
          
          console.log("Using generated order number:", orderNumber);

          // Prepare cart details for confirmation page
          const cartDetailsForConfirmation = cartDetails.map(item => ({
            id: item.id,
            name: item.name,
            quantity: item.quantityPursh,
            price: item.price,
            total: item.price * item.quantityPursh,
            color: item.colorPursh,
            size: item.sizePursh,
            pointure: item.pointurePursh
          }));

          const orderValue = totalCart - promoDiscount + prix;
          await tiktokTrackOrderPlaced({
            orderId: String(orderNumber),
            value: orderValue,
            email: email || undefined,
            phone: Tel || undefined,
            externalId: String(id_client),
            contents: cartDetailsForConfirmation.map((item) => ({
              content_id: String(item.id),
              content_name: item.name,
              content_type: "product",
              quantity: item.quantity,
              price: item.price,
            })),
          });

          analyticsOrderConverted(String(orderNumber));

          setFullName("");
          setTel("");
          setEmail("");
          setAddress("");
          localStorage.clear();

          // Navigate to confirmation page with order number and cart details
          console.log("Navigating to order confirmation with order number:", orderNumber);
          const cartDetailsParam = encodeURIComponent(JSON.stringify(cartDetailsForConfirmation));
          const totalParam = encodeURIComponent((totalCart + prix).toString());
          const shippingFeeParam = encodeURIComponent(prix.toString());
          const promoCodeParam = encodeURIComponent(appliedPromoCode?.code || '');
          const promoDiscountParam = encodeURIComponent(promoDiscount.toString());
          
          navigate(`/order-confirmation?orderNumber=${orderNumber}&paymentMethod=${encodeURIComponent(activePayment)}&deliveryMethod=${encodeURIComponent(deliveryType)}&address=${encodeURIComponent(Address)}&email=${encodeURIComponent(email)}&telephone=${encodeURIComponent(Tel)}&fullName=${encodeURIComponent(fullName)}&cartDetails=${cartDetailsParam}&total=${totalParam}&shippingFee=${shippingFeeParam}&promoCode=${promoCodeParam}&promoDiscount=${promoDiscountParam}`);

        } else {
          console.log("Order submission failed:", orderResponse.data);
          warning("Impossible de passer la commande, veuillez réessayer.");
        }
      }
    } catch (error: any) {
      console.error("Error submitting order:", error);
      
      // Provide more specific error messages
      let errorMessage = "Il y a eu une erreur lors de la soumission de votre commande. Veuillez réessayer.";
      
      if (error.response?.status === 500) {
        errorMessage = "Erreur serveur. Veuillez réessayer dans quelques instants.";
      } else if (error.response?.status === 400) {
        errorMessage = "Données de commande incomplètes. Veuillez vérifier vos informations.";
      } else if (error.code === 'NETWORK_ERROR' || error.message?.includes('Network Error')) {
        errorMessage = "Problème de connexion. Veuillez vérifier votre connexion internet et réessayer.";
      }
      
      warning(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };
  const hasFreeShippingPromoCode =
    Boolean(appliedPromoCode && appliedPromoCode.type === 'free_shipping');
  const deliveryPromoActive = cartQualifiesForDeliveryPromo(
    cartDetails,
    deliveryPromoProductIds
  );

  function delivery(type: string, pri: number) {
    const base = Number(pri) || 0;
    setDeliveryType(type);
    setBaseShippingFee(base);
    setPrix(
      resolveCheckoutShippingFee(
        base,
        cartDetails,
        deliveryPromoProductIds,
        hasFreeShippingPromoCode
      )
    );
  }

  useEffect(() => {
    if (!deliveryType) return;
    setPrix(
      resolveCheckoutShippingFee(
        baseShippingFee,
        cartDetails,
        deliveryPromoProductIds,
        hasFreeShippingPromoCode
      )
    );
  }, [
    cartDetails,
    deliveryPromoProductIds,
    deliveryType,
    baseShippingFee,
    hasFreeShippingPromoCode,
  ]);

  useEffect(() => {
    const livraisonType = cartDetails.filter((e) => e.livraison == 'Express_non');
    setexpressavailable(livraisonType.length > 0);
  }, [cartDetails]);

  const initiateCheckoutTracked = useRef(false);
  useEffect(() => {
    if (initiateCheckoutTracked.current || cartDetails.length === 0) return;
    initiateCheckoutTracked.current = true;
    const subtotal = cartDetails.reduce(
      (sum, item) => sum + Number(item.price || 0) * Number(item.quantityPursh || 1),
      0
    );
    tiktokInitiateCheckout({
      value: subtotal - promoDiscount + prix,
      contents: cartDetails.map((item) => ({
        content_id: String(item.id),
        content_name: String(item.name || ""),
        content_type: "product",
        quantity: Number(item.quantityPursh || 1),
        price: Number(item.price || 0),
      })),
    });
  }, [cartDetails, promoDiscount, prix]);

  
  return (
    <>
      <TopNavThree props="style-three bg-white" />
      <div id="header" className="relative max-sm:mb-5">
        <MenuFurniture props="bg-white" />
      </div>
      <div className="w-full min-h-screen px-3 py-4 overflow-x-hidden">
        {/* Popup Notifications */}
        {showPromoSuccess && (
          <div className="fixed top-4 right-4 z-50 animate-slide-in">
            <div 
              className="popup-notification text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-2 max-w-[85vw] border-2 border-green-700"
              style={{ backgroundColor: '#059669' }}
            >
              <Icon.CheckCircle size={20} className="text-white flex-shrink-0" />
              <div className="min-w-0 flex-1">
                <div className="font-semibold text-sm">Succès !</div>
                <div className="text-xs">{promoMessage}</div>
              </div>
              <button 
                onClick={() => setShowPromoSuccess(false)}
                className="ml-auto text-white hover:text-green-100 flex-shrink-0"
              >
                <Icon.X size={18} />
              </button>
            </div>
          </div>
        )}

        {showPromoError && (
          <div className="fixed top-4 right-4 z-50 animate-slide-in">
            <div 
              className="popup-notification-error text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-2 max-w-[85vw] border-2 border-red-700"
              style={{ backgroundColor: '#dc2626' }}
            >
              <Icon.Warning size={20} className="text-white flex-shrink-0" />
              <div className="min-w-0 flex-1">
                <div className="font-semibold text-sm">Erreur</div>
                <div className="text-xs">{promoMessage}</div>
              </div>
              <button 
                onClick={() => setShowPromoError(false)}
                className="ml-auto text-white hover:text-red-100 flex-shrink-0"
              >
                <Icon.X size={18} />
              </button>
            </div>
          </div>
        )}

        {/* Loading state */}
        {!hasInitialized || isNavigating ? (
          <div className="flex items-center justify-center min-h-[50vh]">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-pink mx-auto mb-4"></div>
              <p className="text-secondary text-base">Chargement...</p>
            </div>
          </div>
        ) : (
          <>
            <div className="max-w-6xl mx-auto px-2 md:px-4 pb-60 md:pb-0">
              <h1 className="text-2xl md:text-3xl font-bold text-center mb-4 md:mb-6 text-pink py-4 md:py-6 px-4">
                <div className="flex items-center justify-center gap-3">
                  <Icon.ClipboardText size={28} weight="duotone" className="text-pink" />
                  <span>Finaliser votre commande</span>
                </div>
              </h1>

              <CheckoutSteps currentStep={2} />

              <div className="grid lg:grid-cols-2 gap-4 md:gap-6">
                {/* Cart Summary - flat card */}
                <div className="bg-[#f5f5f5] rounded-xl border border-gray-200 p-4 md:p-5 flex flex-col gap-4 order-1 lg:order-2">
                  <h2 className="text-base md:text-lg font-semibold mb-1 text-pink flex items-center gap-2">
                    <Icon.ShoppingBag size={22} weight="duotone" />
                    Votre panier
                  </h2>
                  {cartDetails.length === 0 ? (
                    <div className="text-center text-secondary text-sm md:text-base">Votre panier est vide.</div>
                  ) : (
                    <ul className="divide-y divide-line">
                      {cartDetails.map((product, idx) => (
                        <li key={product.variantKey} className="flex items-start gap-3 py-4 bg-white rounded-lg p-3 border border-gray-100">
                          <img 
                            src={
                              product.colorImageId 
                                ? (product.colorImageId.startsWith('/') ? product.colorImageId : `/images/${product.colorImageId}`)
                                : `/images/${product.id}.jpg`
                            } 
                            alt={product.name} 
                            className="w-16 h-16 object-cover rounded-lg border border-gray-100 flex-shrink-0"
                            onError={(e) => {
                              e.currentTarget.src = "/default.png"; 
                            }}
                          />
                          <div className="flex-1 min-w-0">
                            <div className="font-bold text-title text-sm mb-1 line-clamp-2">{product.name}</div>
                            <div className="flex flex-wrap gap-2 mb-2">
                              <span className="bg-gray-100 text-gray-600 text-xs px-2 py-1 rounded-full">ID: {product.id}</span>
                              {hasSelectedVariantValue(product.sizePursh) && (
                                <span className="bg-blue-100 text-blue-600 text-xs px-2 py-1 rounded-full">T: {product.sizePursh}</span>
                              )}
                              {hasSelectedVariantValue(product.pointurePursh) && (
                                <span className="bg-cyan-100 text-cyan-700 text-xs px-2 py-1 rounded-full">P: {product.pointurePursh}</span>
                              )}
                              {hasSelectedVariantValue(product.colorPursh) && (
                                <span className="bg-purple-100 text-purple-600 text-xs px-2 py-1 rounded-full">C: {product.colorPursh}</span>
                              )}
                          </div>
                            <div className="flex justify-between items-center">
                              <div className="text-xs text-gray-500">
                                Qté: {product.quantityPursh} × {Number(product.price).toFixed(2)} MAD
                              </div>
                              <div className="font-bold text-pink text-sm">
                            {(product.price * product.quantityPursh).toFixed(2)} MAD
                              </div>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  )}
                  {/* Promo Code Section - Desktop Only, compact */}
                  <div className="hidden md:block mt-3">
                    <div className="bg-pink-50/70 border border-pink-100 rounded-lg py-2 px-3">
                      <h3 className="text-sm font-semibold text-pink mb-2 flex items-center gap-1.5">
                        <Icon.Ticket size={16} weight="duotone" className="text-pink" />
                        Code Promo
                      </h3>
                      <PromoCodeInput
                        cartTotal={totalCart}
                        shippingCost={prix}
                        onPromoCodeApplied={handlePromoCodeApplied}
                        onPromoCodeRemoved={handlePromoCodeRemoved}
                        appliedPromoCode={appliedPromoCode || undefined}
                        productIds={cartDetails.map(item => Number(item.id))}
                        categories={cartDetails.map(item => item.category).filter(Boolean)}
                      />
                    </div>
                  </div>

                  {/* Desktop Totals - Hidden on Mobile */}
                  <div className="hidden md:block">
                    <div className="flex justify-between items-center mt-3 md:mt-4 pt-3 md:pt-4 border-t border-line">
                      <span className="font-semibold text-sm md:text-base">Sous-total</span>
                      <span className="font-bold text-base md:text-lg text-pink">{totalCart.toFixed(2)} MAD</span>
                  </div>
                  
                  {/* Promo Code Discount */}
                  {promoDiscount > 0 && (
                    <div className="flex justify-between items-center">
                        <span className="text-green-600 font-medium text-xs md:text-sm">Réduction promo</span>
                        <span className="text-green-600 font-medium text-xs md:text-sm">-{promoDiscount.toFixed(2)} MAD</span>
                    </div>
                  )}
                    {hasFreeShippingPromoCode && (
                      <div className="flex justify-between items-center">
                        <span className="text-green-600 font-medium text-xs md:text-sm">Livraison gratuite</span>
                        <span className="text-green-600 font-medium text-xs md:text-sm">Gratuit</span>
                      </div>
                    )}
                    {deliveryType && !hasFreeShippingPromoCode && (
                      <div className="flex justify-between items-center">
                        <span className="text-secondary text-xs md:text-sm">Frais de livraison</span>
                        <span className="font-medium text-xs md:text-sm">{prix} MAD</span>
                      </div>
                  )}
                  
                  <div className="flex justify-between items-center pt-2 border-t border-line">
                      <span className="font-semibold text-sm md:text-base">Total</span>
                      <span className="font-bold text-base md:text-lg text-pink">{(Number(totalCart) - Number(promoDiscount) + Number(prix)).toFixed(2)} MAD</span>
                    </div>
                  </div>
                </div>
                {/* Checkout Form - flat design */}
                <form id="checkout-form" onSubmit={submitOrder} className="bg-[#f5f5f5] rounded-xl border border-gray-200 p-4 md:p-5 flex flex-col gap-4 order-2 lg:order-1" noValidate>
                  <h2 className="text-base md:text-lg font-semibold mb-1 text-pink flex items-center gap-2">
                    <Icon.MapPin size={22} weight="duotone" />
                    Informations de livraison
                  </h2>
                  <div className="flex flex-col gap-1 md:gap-2">
                    <label className="font-medium text-title text-xs md:text-sm flex items-center gap-2">
                      <Icon.User size={18} weight="duotone" className="text-pink" />
                      Nom complet <span className="text-red-500">*</span>
                    </label>
                    <input 
                      type="text" 
                      value={fullName} 
                      onChange={e => setFullName(e.target.value)} 
                      className={`rounded-lg border-2 border-gray-200 bg-white p-2 md:p-3 focus:outline-none focus:border-pink focus:ring-0 text-xs md:text-sm w-full ${
                        fullName.trim() === "" ? 'border-pink-200 bg-pink-50/50' : ''
                      }`}
                      placeholder="Votre nom complet" 
                      title="Veuillez saisir votre nom complet"
                      required 
                    />
                  </div>
                  <div className="flex flex-col gap-1 md:gap-2">
                    <label className="font-medium text-title text-xs md:text-sm flex items-center gap-2">
                      <Icon.Phone size={18} weight="duotone" className="text-pink" />
                      Téléphone <span className="text-red-500">*</span>
                    </label>
                    <input 
                      type="tel" 
                      value={Tel} 
                      onChange={e => setTel(e.target.value)} 
                      className={`rounded-lg border-2 border-gray-200 bg-white p-2 md:p-3 focus:outline-none focus:border-pink focus:ring-0 transition-colors text-xs md:text-sm w-full ${
                        Tel.trim() === "" ? 'border-pink-200 bg-pink-50/50' : 
                        Tel.trim() !== "" && !/^[+]?[0-9\s\-\(\)]+$/.test(Tel) ? 'border-red-300 bg-red-50' :
                        Tel.trim() !== "" && Tel.replace(/[^\d+]/g, '').length < 8 ? 'border-red-300 bg-red-50' : ''
                      }`}
                      placeholder="+212664045333" 
                      title="Veuillez saisir un numéro de téléphone valide"
                      required 
                    />
                    {Tel.trim() !== "" && !/^[+]?[0-9\s\-\(\)]+$/.test(Tel) && (
                      <p className="text-red-500 text-xs md:text-sm">Le numéro ne doit contenir que des chiffres et le symbole '+'</p>
                    )}
                    {Tel.trim() !== "" && /^[+]?[0-9\s\-\(\)]+$/.test(Tel) && Tel.replace(/[^\d+]/g, '').length < 8 && (
                      <p className="text-red-500 text-xs md:text-sm">Le numéro doit contenir au moins 8 chiffres</p>
                    )}
                  </div>
                  <div className="flex flex-col gap-2">
                    <label className="font-medium text-title text-sm flex items-center gap-2">
                      <Icon.EnvelopeSimple size={18} weight="duotone" className="text-pink" />
                      Email <span className="text-gray-400 text-sm">(optionnel)</span>
                    </label>
                    <input 
                      type="email" 
                      value={email} 
                      onChange={e => setEmail(e.target.value)} 
                      className={`rounded-lg border-2 border-gray-200 bg-white p-3 focus:outline-none focus:border-pink focus:ring-0 text-sm w-full ${
                        email.trim() !== "" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? 'border-red-300 bg-red-50' : ''
                      }`}
                      placeholder="nom@domaine.com" 
                      title="Veuillez saisir une adresse email valide"
                    />
                    {email.trim() !== "" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && (
                      <p className="text-red-500 text-sm">Format d'email invalide</p>
                    )}
                  </div>
                  <div className="flex flex-col gap-2">
                    <label className="font-medium text-title text-sm flex items-center gap-2">
                      <Icon.MapPin size={18} weight="duotone" className="text-pink" />
                      Adresse <span className="text-red-500">*</span>
                    </label>
                    <input 
                      type="text" 
                      value={Address} 
                      onChange={e => setAddress(e.target.value)} 
                      className={`rounded-lg border-2 border-gray-200 bg-white p-3 focus:outline-none focus:border-pink focus:ring-0 text-sm w-full ${
                        Address.trim() === "" ? 'border-pink-200 bg-pink-50/50' : ''
                      }`}
                      placeholder="Votre adresse complète" 
                      title="Veuillez saisir votre adresse complète"
                      required 
                    />
                  </div>
                  <div className="flex flex-col gap-2">
                    <label className="font-medium text-title text-sm flex items-center gap-2">
                      <Icon.MapTrifold size={18} weight="duotone" className="text-pink" />
                      Ville <span className="text-red-500">*</span>
                    </label>
                    <select
                      value={city} 
                      onChange={e => setCity(e.target.value)} 
                      className={`rounded-lg border-2 border-gray-200 bg-white p-3 focus:outline-none focus:border-pink focus:ring-0 text-sm w-full ${
                        city === "" ? 'border-pink-200 bg-pink-50/50' : ''
                      }`}
                      title="Veuillez sélectionner une ville"
                      required
                    >
                      <option value="">Sélectionnez une ville</option>
                      {livraison.map((cityItem) => (
                        <option key={cityItem.id} value={cityItem.city}>
                          {cityItem.city}
                        </option>
                      ))}
                    </select>
                  </div>
                  {/* Delivery Options - flat */}
                  {city && livraison.filter(e => e.city === city).map((cityData) => (
                    <div key={cityData.id} className={`bg-white rounded-lg p-4 border-2 ${
                      deliveryType === "" ? 'border-pink-200 bg-pink-50/30' : 'border-gray-200'
                    }`}>
                      <h3 className="font-semibold text-title mb-3 text-sm flex items-center gap-2">
                        <Icon.Truck size={18} weight="duotone" className="text-pink" />
                        Livraison pour {cityData.city} <span className="text-red-500">*</span>
                      </h3>
                      {deliveryPromoActive && (
                        <p className="text-green-600 text-xs mb-2">
                          Livraison offerte pour ce produit (panier à un seul article).
                        </p>
                      )}
                      <div className="space-y-3">
                        <label className={`flex items-center space-x-3 cursor-pointer p-3 rounded-lg border-2 transition-colors ${
                          deliveryType === "standard" ? 'border-pink bg-pink-50' : 'border-gray-200 hover:border-pink-200 hover:bg-pink-50/50'
                        }`}>
                          <input
                            type="radio"
                            name="deliveryType"
                            value="standard"
                            checked={deliveryType === "standard"}
                            onChange={() => delivery("standard", cityData.standard)}
                            className="text-pink focus:ring-pink"
                            required
                          />
                          <div className="flex-1">
                            <div className="font-medium text-sm">Livraison Standard</div>
                            <div className="text-sm text-secondary">
                              {resolveCheckoutShippingFee(
                                cityData.standard,
                                cartDetails,
                                deliveryPromoProductIds,
                                hasFreeShippingPromoCode
                              )}{' '}
                              MAD
                            </div>
                          </div>
                        </label>
                        {cityData.express > 0 && (
                          <label className={`flex items-center space-x-3 cursor-pointer p-3 rounded-lg border-2 transition-colors ${
                            deliveryType === "express" ? 'border-pink bg-pink-50' : 'border-gray-200 hover:border-pink-200 hover:bg-pink-50/50'
                          }`}>
                            <input
                              type="radio"
                              name="deliveryType"
                              value="express"
                              checked={deliveryType === "express"}
                              onChange={() => delivery("express", cityData.express)}
                              className="text-pink focus:ring-pink"
                              required
                            />
                            <div className="flex-1">
                              <div className="font-medium text-sm">Livraison Express</div>
                              <div className="text-sm text-secondary">
                                {resolveCheckoutShippingFee(
                                  cityData.express,
                                  cartDetails,
                                  deliveryPromoProductIds,
                                  hasFreeShippingPromoCode
                                )}{' '}
                                MAD
                              </div>
                            </div>
                          </label>
                        )}
                      </div>
                      {deliveryType === "" && (
                        <p className="text-red-500 text-sm mt-2">Veuillez sélectionner une option de livraison</p>
                      )}
                    </div>
                  ))}
                  {/* Payment Options - flat */}
                  <div className={`bg-white rounded-lg p-4 border-2 ${
                    activePayment === "" ? 'border-pink-200 bg-pink-50/30' : 'border-gray-200'
                  }`}>
                    <h3 className="font-semibold text-title mb-3 text-sm flex items-center gap-2">
                      <Icon.CreditCard size={18} weight="duotone" className="text-pink" />
                      Mode de paiement <span className="text-red-500">*</span>
                    </h3>
                    <div className="space-y-3">
                      <label className={`flex items-center space-x-3 cursor-pointer p-3 rounded-lg border-2 transition-colors ${
                        activePayment === "paiement à la livraison" ? 'border-pink bg-pink-50' : 'border-gray-200 hover:border-pink-200 hover:bg-pink-50/50'
                      }`}>
                        <input
                          type="radio"
                          name="payment"
                          value="paiement à la livraison"
                          checked={activePayment === "paiement à la livraison"}
                          onChange={() => handlePayment("paiement à la livraison")}
                          className="text-pink focus:ring-pink"
                          required
                        />
                        <div className="flex items-center space-x-2 flex-1">
                          <svg className="w-5 h-5 text-green-600 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                          </svg>
                          <div>
                            <div className="font-medium text-sm">Paiement à la livraison</div>
                            <div className="text-sm text-secondary">Payez en espèces ou par carte à la réception</div>
                          </div>
                        </div>
                      </label>
                      <label className="flex items-center space-x-3 cursor-not-allowed opacity-50">
                        <input
                          type="radio"
                          name="payment"
                          value="carte bancaire"
                          checked={activePayment === "carte bancaire"}
                          onChange={() => handlePayment("carte bancaire")}
                          className="text-gray-400 focus:ring-gray-400"
                          disabled
                        />
                        <div className="flex items-center space-x-2 flex-1">
                          <svg className="w-5 h-5 text-gray-400 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4zM18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z" />
                          </svg>
                          <div>
                            <div className="font-medium text-gray-400 text-sm">Carte bancaire</div>
                            <div className="text-sm text-gray-400">Non disponible pour le moment</div>
                          </div>
                        </div>
                      </label>
                    </div>
                    {activePayment === "" && (
                      <p className="text-red-500 text-sm mt-2">Veuillez sélectionner un mode de paiement</p>
                    )}
                  </div>
                  {/* Submit Button - flat */}
                  <button 
                    type="submit" 
                    disabled={isSubmitting}
                    className="hidden md:flex w-full bg-pink text-white font-bold py-3 px-4 rounded-lg mt-4 items-center justify-center gap-2 text-base border-0 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-pink-600 transition-colors"
                  >
                    {isSubmitting ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent" />
                        <span className="text-sm">Traitement... {Math.round(loadingProgress)}%</span>
                      </>
                    ) : (
                      <>
                        <Icon.CheckCircle size={22} weight="duotone" />
                        <span>Confirmer la commande</span>
                      </>
                    )}
                  </button>
                  
                  {/* Progress Bar */}
                  {isSubmitting && (
                    <div className="hidden md:block w-full mt-3">
                      <div className="w-full bg-gray-200 rounded-full h-2">
                        <div 
                          className="bg-green-500 h-2 rounded-full transition-all duration-100 ease-out"
                          style={{ width: `${loadingProgress}%` }}
                        ></div>
                      </div>
                      <p className="text-sm text-gray-600 mt-1 text-center">
                        Préparation de votre commande...
                      </p>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </>
        )}
        


        {/* Mobile Sticky Bottom Section - flat */}
        <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t-2 border-gray-200 z-50">
          <div className="px-4 py-3">
            {/* Compact Promo Code Section */}
            <div className="mb-3 bg-white border-2 border-gray-200 rounded-lg p-2">
              <div className="flex gap-2">
                <input
                  type="text"
                  placeholder="Code promo"
                  className="flex-1 border-2 border-gray-200 rounded-lg px-2 py-2 text-xs focus:outline-none focus:border-pink focus:ring-0 bg-white"
                  value={promoCode || ''}
                  onChange={(e) => setPromoCode(e.target.value.toUpperCase())}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleApplyPromoCode();
                    }
                  }}
                />
                <button
                  onClick={handleApplyPromoCode}
                  disabled={!promoCode?.trim() || isLoading}
                  className="bg-pink text-white px-3 py-2 rounded-lg border-0 hover:bg-pink-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-xs font-medium flex items-center justify-center min-w-[40px]"
                >
                  {isLoading ? (
                    <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
                  ) : (
                    <Icon.Check size={14} />
                  )}
                </button>
      </div>
              
              {appliedPromoCode && (
                <div className="mt-2 p-2 bg-green-50 border border-green-200 rounded text-green-700 text-xs flex items-center justify-between">
                  <span>✓ {appliedPromoCode.code} (-{promoDiscount.toFixed(2)} MAD)</span>
                  <button
                    onClick={handlePromoCodeRemoved}
                    className="text-red-500 hover:text-red-700 ml-2"
                  >
                    <Icon.X size={12} />
                  </button>
                </div>
              )}
              
              {error && (
                <div className="mt-2 p-1 bg-red-50 border border-red-200 rounded text-red-700 text-xs">
                  {error}
                </div>
              )}
            </div>

            {/* Summary Section */}
            <div className="flex justify-between items-center mb-2">
              <span className="text-sm font-medium text-gray-600">Sous-total</span>
              <span className="text-sm font-semibold">{totalCart.toFixed(2)} MAD</span>
            </div>
            
            {/* Promo Discount */}
            {promoDiscount > 0 && (
              <div className="flex justify-between items-center mb-2">
                <span className="text-sm text-green-600">Réduction promo</span>
                <span className="text-sm text-green-600 font-medium">-{promoDiscount.toFixed(2)} MAD</span>
              </div>
            )}
            
            {/* Shipping */}
            {deliveryType && !hasFreeShippingPromoCode && (
              <div className="flex justify-between items-center mb-2">
                <span className="text-sm text-gray-600">Frais de livraison</span>
                <span className="text-sm font-medium">{prix} MAD</span>
              </div>
            )}
            
            {/* Free Shipping */}
            {hasFreeShippingPromoCode && (
              <div className="flex justify-between items-center mb-2">
                <span className="text-sm text-green-600">Livraison gratuite</span>
                <span className="text-sm text-green-600 font-medium">Gratuit</span>
              </div>
            )}
            
            {/* Total */}
            <div className="flex justify-between items-center pt-2 border-t border-gray-200 mb-3">
              <span className="text-base font-bold text-gray-800">Total</span>
              <span className="text-lg font-bold text-pink">{(totalCart - promoDiscount + prix).toFixed(2)} MAD</span>
            </div>
            
            {/* Fixed Order Button */}
            <button 
              onClick={(e) => {
                e.preventDefault();
                submitOrder(e as any);
              }}
              disabled={isSubmitting}
              className="w-full bg-pink text-white font-bold py-4 rounded-lg hover:bg-pink-600 transition-colors text-base shadow-md flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isSubmitting ? (
                <>
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                  <span>Traitement... {Math.round(loadingProgress)}%</span>
                </>
              ) : (
                <>
                  <Icon.CheckCircle size={20} />
                  <span>Confirmer la commande</span>
                </>
              )}
            </button>
          </div>
        </div>
      </div>
      <div className="hidden md:block">
      <Footer />
      </div>
    </>
  );
};

export default Checkout;

